function getRouter (tab) {
    // 目前采用一个表单一个tab并使用keep-alive，所以不需要使用全路由跳转
    // if (Object.keys(tab.query).length > 0) return {path: tab.path, query: tab.query}
    // if (Object.keys(tab.params).length > 0) return {name: tab.routerName, params: tab.params}
    return tab.path
}
import toolFunction from '@/utils/toolFunction'
import rootHttpClient from '@/http/interceptors'
const state = {
    targetUser: '',
    dialogVisible: false,
    unReadNumber: '',
    userList: []
}
const actions = {
    async refresh_unReadMessage_num ({ commit }) {
        const { username, db_name } = toolFunction.getUserInfo()
        const res = await rootHttpClient.rootModule.get('/toolAPI/api/WebFrame/pbFrameNotifyMessage/', {
            type: -1,
            to_user: username,
            db_name: db_name
        })
        const item0 = res.data.length ? res.data[0] : {}
        commit('updateUnReadNumber', item0.un_read_count)
    },
    async getUserList ({ commit }) {
        const { db_name } = toolFunction.getUserInfo()
        const res = await rootHttpClient.rootModule.get('/toolAPI/api/WebFrame/pbFrameNotifyMessage/User/', {
            db_name: db_name
        })
        const item0 = res.data || []
        item0.forEach(item => {
            if (item.user_no) {// 转换成小写
                item.user_no = item.user_no.toLowerCase()
            }
        })
        commit('updateUserList', item0)
    }

}
const mutations = {
    set_targetUser (state, targetUser) {
        state.targetUser = targetUser
    },
    set_dialogVisible (state, value) {
        state.dialogVisible = value
    },
    updateUnReadNumber (state, value) {
        state.unReadNumber = value
    },
    updateUserList (state, value) {
        state.userList = value
    }

}
const getters = {
    targetUser: state => state.targetUser,
    dialogVisible: state => state.dialogVisible,
}
const globalStore = {
    state,
    getters,
    mutations,
    actions
}
export default globalStore



// WEBPACK FOOTER //
// ./src/store/modules/wechat.js